import { z } from 'zod';

export const ConfigAdminSchema = z.object({
  clientId: z
    .string()
    .min(
      1,
      'Enter a new Client ID here. This also requires a new Principal Client Secret below.',
    ),
  clientSecret: z
    .string()
    .min(
      1,
      'Enter the new service principal secret you generated in Databricks',
    ),
});

export type ConfigAdminFormValues = z.infer<typeof ConfigAdminSchema>;
